import { Modal, Radio, Space, Typography } from "antd";
import type React from "react";
import { useState } from "react";
import type { AppointmentOption } from "../../types/index.type";

const { Text } = Typography;

interface AppointmentSelectionModalProps {
  visible: boolean;
  appointments: AppointmentOption[];
  onSelect: (appointmentId: string) => void;
  onCancel: () => void;
  loading: boolean;
  title?: string;
  description?: string;
}

const AppointmentSelectionModal: React.FC<AppointmentSelectionModalProps> = ({
  visible,
  appointments,
  onSelect,
  onCancel,
  loading,
  title,
  description,
}) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const handleOk = () => {
    if (selectedId) {
      onSelect(selectedId);
    }
  };

  return (
    <Modal
      title={title || "Select Appointment"}
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Select"
      cancelText="Cancel"
      okButtonProps={{ disabled: !selectedId, loading }}
      cancelButtonProps={{ disabled: loading }}
      width={600}
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      zIndex={1000}
    >
      <div style={{ marginBottom: 16 }}>
        <Text>
          {description ||
            "Multiple appointments were found for this patient. Please select the appointment you want to transfer the note to:"}
        </Text>
      </div>

      <div style={{ maxHeight: 400, overflowY: "auto" }}>
        <Radio.Group onChange={(e) => setSelectedId(e.target.value)} value={selectedId} style={{ width: "100%" }}>
          <Space direction="vertical" style={{ width: "100%" }}>
            {appointments.map((apt) => (
              <Radio key={apt.id} value={apt.id} style={{ width: "100%" }}>
                <div style={{ display: "flex", flexDirection: "column", paddingLeft: 8 }}>
                  <Text strong>
                    {apt.date || "Unknown date"}
                    {apt.time ? ` at ${apt.time}` : ""}
                  </Text>
                  {apt.visit_type && <Text type="secondary">{apt.visit_type}</Text>}
                  {apt.provider && <Text type="secondary">Provider: {apt.provider}</Text>}
                  {apt.location && <Text type="secondary">Location: {apt.location}</Text>}
                </div>
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </div>
    </Modal>
  );
};

export default AppointmentSelectionModal;
